import {Spinner} from '@primer/react'
import type {StackSectionEntryType} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import type {StackRebasePullRequestStatus} from '../../../hooks/mutations/use-stack-rebase-mutation'
import {AlertIcon, CheckCircleFillIcon} from '@primer/octicons-react'
import {ENTRY_STATUS_INFO} from './EntryStatusLabel'

export function EntryStatusIcon({
  entry,
  rebaseState,
}: {
  entry: StackSectionEntryType
  rebaseState?: StackRebasePullRequestStatus
}) {
  // Rebasing
  if (rebaseState === 'PENDING') {
    return <Spinner size="small" style={{marginLeft: -2}} />
  } else if (rebaseState === 'SUCCEEDED') {
    return <CheckCircleFillIcon size={12} className="color-fg-success" aria-label="Rebased successfully" />
  } else if (rebaseState === 'CONFLICTED') {
    return <AlertIcon size={12} className="color-fg-attention" aria-label="Merge conflicts after rebasing" />
  } else if (rebaseState === 'FAILED') {
    return <AlertIcon size={12} className="color-fg-attention" aria-label="Rebase failed" />
  }

  const {icon} = ENTRY_STATUS_INFO[entry.status]
  if (icon.type === 'spinner') {
    return <Spinner size="small" style={{marginLeft: -2}} />
  }
  const EntryIcon = icon.icon
  return <EntryIcon size={12} className={icon.className} aria-label={icon.ariaLabel} />
}
